import React from "react";
import { connect } from "react-redux";
import { formValueSelector, reduxForm } from "redux-form";
import {ff, form, utils} from "@mc/mc-legacy";
import * as textNoteActions from "../../actions/textNoteActions";
const { Form, FormBody, FormActions } = form;

const validate = (formData) => {
  const errors = {};

  if (!formData.note) {
    errors.note = "Povinný parametr";
  }

  return errors;
};

class TextNoteForm extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.fetchData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    props.dispatch(textNoteActions.fetchTextNotesIfNeeded());
  };

  static formName = "TextNoteForm";
  render() {
    const { onClose, submitting, handleSubmit, onSubmit, TextNoteList } = this.props;
    // const renderApprovers = ({fields, step, stepFields, stepIndex}) => {
    //   const { steps, ApproverList } = this.props;
    //     const schvalovatelItems = [];
    //     ApproverList.rows &&
    //     ApproverList.rows.forEach((item) => {
    //         schvalovatelItems.push({
    //             id: item.pracovnik.id,
    //             name: `${item.pracovnik.uplneJmeno} ${item.pracovnik.organizacniJednotka ? `(${item.pracovnik.organizacniJednotka.kod})` : ""}`,
    //             title: item.pracovnik.organizacniJednotka.nazev,
    //           });
    //     });
    //
    //   return (
    //       <div className="step-approvers">
    //           {fields.map((field, index) => {
    //               const approver = step.approvers[index];
    //               const removeStep = fields.length == 1;
    //               return <Row noGutters className="approver" key={index}>
    //                   <Col>
    //                      <ff.Autocomplete
    //                          name={field + ".pracovnikId"}
    //                          items={schvalovatelItems}
    //                          useIdAsValue={true}
    //                          label={false}
    //                          renderItemContent={(item, name) => {
    //                              if (name && name.length > 0) {
    //                                  return (
    //                                      <span title={item.title ? item.title : ""} className="item-text">
    //                                        {name}
    //                                      </span>
    //                                  );
    //                              } else {
    //                                  return <span className="item-text">&nbsp;</span>;
    //                              }
    //                          }}
    //                      />
    //                   </Col>
    //                   {(<Col className="d-flex justify-content-center" xs="auto">
    //                       <Button
    //                           className="d-flex align-self-center mt-1 btn-transparent"
    //                           title="Odebrat schvalovatele"
    //                           onClick={() => {
    //                               fields.remove(index);
    //                               removeStep && stepFields.remove(stepIndex)
    //                           }}>
    //                           <Icon size="lg" icon={"trash-o"} />
    //                       </Button>
    //                   </Col>)}
    //                   {index + 1 == fields.length && (<Col className="d-flex justify-content-center mt-2" xs="auto">
    //                       <Button
    //                           className="d-flex align-self-center btn-transparent"
    //                           title="Přidat schvalovatele"
    //                           onClick={() => {fields.push({pracovnikId: null, flowId: null})}}>
    //                           <Icon size="lg" icon={"plus-square-o"} />
    //                       </Button>
    //                   </Col>)}
    //               </Row>
    //           })}
    //       </div>
    //   );
    // };

    // const renderSteps = ({fields}) => {
    //   const {submitting, steps} = this.props;
    //   return (
    //       <di>
    //           {fields.map((field, index) => {
    //               if (steps) {
    //                   const step = steps[index];
    //                   return <Row noGutters className="step mb-2" key={index}>
    //                       <Col>
    //                           {"Krok č. " + (index + 1)}
    //                           <FieldArray name={field + ".approvers"} step={step} stepFields={fields}
    //                                       stepIndex={index} component={renderApprovers}/>
    //                       </Col>
    //                   </Row>
    //               } else {
    //                   return <Loader key={index}/>;
    //               }
    //           })}
    //           <Button
    //               className="btn-transparent p-0 mt-2"
    //               title="Přidat krok"
    //               onClick={() => {
    //                   fields.push({name: "Krok č. " + (steps.length + 1), everyone: false, approvers: [{pracovnikId: null, flowId: null}]})
    //               }}>
    //               <Icon size="lg" icon={"plus-square-o"} className={"mr-2"} />Přidat krok
    //           </Button>
    //       </di>
    //   );
    // };

    return (
      <Form onSubmit={handleSubmit}>
          <FormBody>
              <ff.Textarea required label="Poznámka" name="note" disabled={submitting}/>
          </FormBody>
          <FormActions onClose={onClose} storeButton cancelButton disabled={submitting}/>
      </Form>
    );
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(TextNoteForm.formName);
  return {
    TextNoteList: utils.storeFromArea(state, textNoteActions.TEXT_NOTE_LIST),
  };
}

const reduxFormObj = reduxForm({
  form: TextNoteForm.formName,
  validate: validate,
})(TextNoteForm);
export default connect(mapStateToProps)(reduxFormObj);
